import React from 'react';
import List from '@mui/material/List';
import QuestionAnswerItem from './QuestionAnswerItem/QuestionAnswerItem';

const QuestionAnswerList = ({ items }) => (
  <List disablePadding>
    {items.map((qa, idx) => (
      <QuestionAnswerItem key={qa.id || idx} qa={qa} index={idx} />
    ))}
  </List>
);

export default QuestionAnswerList;
